import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { User, Mail, Phone, MapPin, ArrowLeft } from 'lucide-react';
import './RegistrationStyles.css';

const url = process.env.REACT_APP_BACKEND_URL;

const EditCustomer = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    fullname: "",
    address: "",
    phone: "",
    email: ""
  });

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const response = await axios.get(`${url}/api/customer/${id}`);
        const customer = response.data.data;
        setData({
          fullname: customer.fullname,
          address: customer.address,
          phone: customer.phone,
          email: customer.email
        });
      } catch (error) {
        toast.error("Failed to load customer data");
        navigate('/registration/customers');
      }
    };

    fetchCustomer();
  }, [id, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.put(
        `${url}/api/customer/${id}`,
        data
      );

      if (response.data.success) {
        toast.success("Customer updated successfully!");
        navigate('/registration/customers');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update customer");
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="form-wrapper">
      <div className="form-card">
        <button onClick={() => navigate('/registration/customers')} className="back-btn">
          <ArrowLeft size={16} /> Back to List
        </button>

        <h2 className="form-title">
          <User size={24} /> Edit Customer
        </h2>

        <form className="dynamic-form" onSubmit={handleSubmit}>
          <div className="form-field filled">
            <input
              type="text"
              name="fullname"
              value={data.fullname}
              onChange={handleChange}
              required
            />
            <label>Full Name</label>
            <User size={18} className="field-icon" />
          </div>

          <div className="form-field filled">
            <input
              type="text"
              name="address"
              value={data.address}
              onChange={handleChange}
              required
            />
            <label>Address</label>
            <MapPin size={18} className="field-icon" />
          </div>

          <div className="form-field filled">
            <input
              type="tel"
              name="phone"
              value={data.phone}
              onChange={handleChange}
              required
            />
            <label>Phone Number</label>
            <Phone size={18} className="field-icon" />
          </div>

          <div className="form-field filled">
            <input
              type="email"
              name="email"
              value={data.email}
              onChange={handleChange}
              required
            />
            <label>Email Address</label>
            <Mail size={18} className="field-icon" />
          </div>

          <div className="form-actions">
            <button
              type="submit"
              className="submit-btn"
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update Customer"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCustomer;